import React from 'react'
import MyButton from '../../../UI/form/MyButton'
import MySpiner from '../../../UI/spiner/MySpiner'
import { useState } from 'react'
import { useEffect } from 'react'
import PackingConfirmFieldScaner from './fileds/PackingConfirmFieldScaner'
import PackingConfirmResult from './PackingConfirmResult'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { packingBoxInPackByScanConfirmAPI } from '../../../../api/pack/seriesAPI'

const PackingConfirmForm = () => {

    const [scannedGood, setScannedGood] = useState(null)
    // Товар, що отримано в результаті сканування
    const [goodFromBd, setGoodFromBd] = useState(null)

    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')
    const [errorMain, setErrorMain] = useState('')
    const [loading, setLoading] = useState(false)

    const [reset, setReset] = useState(false)
    
    const [valid, setValid] = useState(false)

    console.log('goodFromBd', goodFromBd)

    useEffect(() => {
        validateForm()
    }, [goodFromBd])

    // Скидання відсканованих товарів
    const resetDataScanned = () => {
        setScannedGood(null)
        setGoodFromBd(null)
        setSuccess('')
        setError('')
        setLoading(false)
    }

    const confirm = () => {
        setLoading(true)
        setSuccess('')
        setError('')

        packingBoxInPackByScanConfirmAPI({
            dataForConfirm: goodFromBd
        }).then(data => {
            console.log('Пакування товау успішно підтверджено')
            console.log('data', data)
            setSuccess('Пакування товау успішно підтверджено')
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    // Перевіряємо наявність всіх отриманих товарів з БД після сканування
    // Роблю це на всяк випадок, якщо необхідно буде сканувати не лише 1 товар, щоб потім не дороблювати багато
    const validateForm = () => {
        let validTemp = true

        // if (goodFromBd) {
        //     // const keys = Object.keys(goodsFromBd)
        //     // for (const key of keys) {
        //     //     if (!goodsFromBd[key]) {
        //     //         validTemp = false
        //     //     }
        //     // }
        // } else {
        //     validTemp = false
        // }

        if (!goodFromBd) { // Якщо немає результату після сканування, то не дозволяти пакування
            validTemp = false
        }

        setValid(validTemp)
    }

  return (
    <div className='myBlock__content'>
        <p>
            В цьому розділі відбувається підтвердження пакування товарів у кінцеву партію для відгрузки <b>співробітником ВТК</b>
		</p>
        <p>
            Після того, як пакувальник поклав все в коробку і підтвердив пакування, співробітнику ВТК необхідно:
        </p>
         <ul>
            <li>Перевірити комплектність коробки</li>
            <li>Зрізати всі бірки з QR-кодами</li>
            <li>Підтвердити комплектність</li>
            <li>Закрити коробку</li>
        </ul>
        <p>
            Відскануйте будь-який товар з наступних:
        </p>
        <ul>
            <li>Дрон</li>
            <li>Котушка</li>
        </ul>

        {
			scannedGood || errorMain ?
				<MyButton
					color='red'
					// onClick={reset}
					onClick={e => {
						// setGoodDataMain(null)
						// setGoodDataNew(null)
                        resetDataScanned()
						setError('')
						setErrorMain('')
						setReset(true)
					}}
				>
					Нове сканування
				</MyButton>
			: ''
		}

        <PackingConfirmFieldScaner 
            valueScan={scannedGood}
            setValueScan={e => {
                setScannedGood(e)
                // setValueForm(setScannedGoods, 'drone', e)
            }}
            setGoodFromBd={e => {
                setGoodFromBd(e)
                // setValueForm(setGoodsFromBd, 'drone', e)
            }}
            reset={reset}
            setReset={setReset}
            // setScannedGood={e => setValueForm(setScannedGoods, 'drone', e)}
            header='Зчитати QR-код упакованого товару з коробки'
            // goodType='drone'
            goodFromBd={goodFromBd}
        />

        {
            goodFromBd ?
                <PackingConfirmResult 
                    resultData={goodFromBd}
                />
            : ''
        }

        {
			success ?
				<div className='success'>
					{success}
				</div>
			: ''
		}

		{
			error ?
				<div className='error'>
					{error}
				</div>
			: ''
		}

        {
            loading ? <MySpiner /> : ''
        }

		{
			// goodDataMain && goodDataNew ?
				<MyButton
					onClick={confirm}
					disabled={loading || !valid || success ? true : false}
				>
					Підтвердити комплектність коробки
				</MyButton>
			// : ''
		}

    </div>
  )
}

export default PackingConfirmForm